(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arden-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const addChooseSystemAnchor = () => {
      const showcase = document.querySelector('.arden-system-showcase');
      if (showcase && !document.getElementById('choose-your-system')) showcase.id = 'choose-your-system';
    };

    addChooseSystemAnchor();

    document.querySelectorAll('[data-arden-video-hero]').forEach((hero) => {
      if (hero.dataset.ardenVideoHeroReady === 'true') return;
      hero.dataset.ardenVideoHeroReady = 'true';

      const video = hero.querySelector('[data-arden-hero-video]');
      const control = hero.querySelector('[data-arden-video-control]');
      const controlLabel = hero.querySelector('[data-arden-video-control-label]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileViewport = window.matchMedia('(max-width: 749px)');
      let isVisible = false;
      let manuallyPaused = false;

      const sourceForViewport = () => {
        if (mobileViewport.matches && video.dataset.mobileVideo) return video.dataset.mobileVideo;
        return video.dataset.desktopVideo;
      };

      const updateControl = () => {
        if (!control || !controlLabel) return;
        const isPlaying = !video.paused && !video.ended;
        const label = isPlaying ? control.dataset.pauseLabel : control.dataset.playLabel;
        controlLabel.textContent = label;
        control.setAttribute('aria-label', label);
        control.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      };

      const loadVideo = () => {
        const source = sourceForViewport();
        if (!source || reducedMotion.matches) return false;
        if (video.dataset.activeSource !== source) {
          video.pause();
          video.src = source;
          video.dataset.activeSource = source;
          video.load();
        }
        return true;
      };

      const play = () => {
        if (!isVisible || manuallyPaused || !loadVideo()) return;
        video.play().then(() => {
          hero.dataset.videoPlaying = 'true';
          updateControl();
        }).catch(updateControl);
      };

      const pause = () => {
        video.pause();
        hero.dataset.videoPlaying = 'false';
        updateControl();
      };

      const observer = new IntersectionObserver((entries) => {
        isVisible = entries[0].isIntersecting;
        if (isVisible) play();
        else pause();
      }, { threshold: 0.1 });

      observer.observe(hero);
      video.addEventListener('playing', () => {
        hero.dataset.videoPlaying = 'true';
        updateControl();
      });
      video.addEventListener('pause', () => {
        hero.dataset.videoPlaying = 'false';
        updateControl();
      });

      control?.addEventListener('click', () => {
        if (video.paused) {
          manuallyPaused = false;
          play();
        } else {
          manuallyPaused = true;
          pause();
        }
      });

      const refreshForViewport = () => {
        if (!isVisible || reducedMotion.matches) return;
        video.dataset.activeSource = '';
        play();
      };

      mobileViewport.addEventListener('change', refreshForViewport);
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) pause();
        else {
          manuallyPaused = false;
          play();
        }
      });

      hero.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          addChooseSystemAnchor();
          const targetId = link.getAttribute('href').slice(1);
          if (!targetId) return;
          const target = document.getElementById(targetId);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      updateControl();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arden-mk-system-purchase"]) return;
  try {
    
  document.querySelectorAll('[data-mk-configurator]').forEach((section) => {
    const variants = Array.from(section.querySelectorAll('[data-mk-variant]'));
    const systems = Array.from(section.querySelectorAll('[data-mk-system]'));
    const finish = section.querySelector('[data-mk-finish]');
    const finishes = Array.from(section.querySelectorAll('[data-mk-finish-choice]'));
    const price = section.querySelector('[data-mk-price]');
    const compare = section.querySelector('[data-mk-compare]');
    const add = section.querySelector('[data-mk-add]');
    const image = section.querySelector('[data-mk-hero-image]');
    let selectedSystem = variants.find((variant) => variant.checked)?.dataset.system || 'cinema';

    const getVariant = (system, finishChoice) => variants.find((variant) => variant.dataset.system === system && (!finishChoice || variant.dataset.finish === finishChoice));
    const update = (variant) => {
      if (!variant) return;
      variant.checked = true;
      const available = variant.dataset.available === 'true' && !variant.disabled;
      price.textContent = variant.dataset.price || '';
      compare.hidden = !variant.dataset.compare;
      compare.textContent = variant.dataset.compare || '';
      add.disabled = !available;
      add.textContent = available ? add.dataset.availableText : add.dataset.soldOutText;
      if (image && variant.dataset.image) {
        image.src = variant.dataset.image;
        image.alt = variant.dataset.imageAlt || image.alt;
      }
      systems.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mkSystem === selectedSystem)));
      finish.dataset.mkActive = 'true';
      finishes.forEach((button) => {
        const selectedFinish = variant.dataset.finish || 'black';
        button.setAttribute('aria-pressed', String(button.dataset.mkFinishChoice === selectedFinish));
      });
    };

    systems.forEach((button) => button.addEventListener('click', () => {
      selectedSystem = button.dataset.mkSystem;
      update(getVariant(selectedSystem, selectedSystem === 'compact' ? 'black' : ''));
    }));
  finishes.forEach((button) => button.addEventListener('click', () => {
    selectedSystem = 'compact';
    update(getVariant('compact', button.dataset.mkFinishChoice));
  }));
    update(variants.find((variant) => variant.checked));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arden-system-bundle-purchase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-asbp]').forEach((section) => {
    const select = section.querySelector('[data-asbp-select]');
    const setupOptions = section.querySelectorAll('[data-asbp-option]');
    const price = section.querySelector('[data-asbp-price]');
    const compare = section.querySelector('[data-asbp-compare]');
    const add = section.querySelector('[data-asbp-add]');

    const updatePurchaseState = (option) => {
      if (!option) return;
      const available = option.dataset.available === 'true' && !option.disabled;
      price.textContent = option.dataset.price || '';

      if (option.dataset.compare) {
        compare.hidden = false;
        compare.textContent = option.dataset.compare;
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }

      add.disabled = !available;
      add.textContent = available ? add.dataset.availableText || add.textContent : add.dataset.soldOutText || add.textContent;
    };

    if (select) {
      select.addEventListener('change', () => {
        updatePurchaseState(select.options[select.selectedIndex]);
      });
    }

    setupOptions.forEach((option) => {
      option.addEventListener('change', () => {
        updatePurchaseState(option);
      });
    });

    const lightbox = section.querySelector('[data-asbp-lightbox]');
    const thumbs = Array.from(section.querySelectorAll('[data-asbp-lightbox-thumb]'));
    const lightboxImage = section.querySelector('[data-asbp-lightbox-image]');
    const closeLightbox = section.querySelector('[data-asbp-lightbox-close]');
    const prevLightbox = section.querySelector('[data-asbp-lightbox-prev]');
    const nextLightbox = section.querySelector('[data-asbp-lightbox-next]');
    const mediaTrack = section.querySelector('.asbp-media');
    const mediaCounter = section.querySelector('[data-asbp-media-counter]');
    let activeImageIndex = 0;
    let previousBodyOverflow = '';
    let pointerStartX = 0;
    let pointerStartY = 0;
    let didSwipeMedia = false;

    const showLightboxImage = (index) => {
      if (!thumbs.length || !lightboxImage) return;
      activeImageIndex = (index + thumbs.length) % thumbs.length;
      const nextSrc = thumbs[activeImageIndex].dataset.lightboxSrc;
      if (nextSrc) {
        lightboxImage.src = nextSrc;
      }
    };

    const openLightbox = (index) => {
      if (!lightbox || !thumbs.length) return;
      showLightboxImage(index);
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      lightbox.hidden = false;
      closeLightbox?.focus();
    };

    const hideLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      if (lightboxImage) {
        lightboxImage.removeAttribute('src');
      }
      document.body.style.overflow = previousBodyOverflow;
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        didSwipeMedia = false;
      });

      thumb.addEventListener('pointermove', (event) => {
        if (Math.abs(event.clientX - pointerStartX) > 10 || Math.abs(event.clientY - pointerStartY) > 10) {
          didSwipeMedia = true;
        }
      });

      thumb.addEventListener('click', () => {
        if (didSwipeMedia) return;
        openLightbox(index);
      });
    });

    const updateMediaCounter = () => {
      if (!mediaTrack || !mediaCounter || !thumbs.length) return;
      const current = Math.round(mediaTrack.scrollLeft / mediaTrack.clientWidth) + 1;
      const clamped = Math.min(Math.max(current, 1), thumbs.length);
      const separator = mediaCounter.dataset.counterSeparator || '/';
      mediaCounter.textContent = `${String(clamped).padStart(2, '0')} ${separator} ${String(thumbs.length).padStart(2, '0')}`;
    };

    let mediaCounterFrame = null;
    mediaTrack?.addEventListener('scroll', () => {
      if (!mediaCounter) return;
      if (mediaCounterFrame) {
        window.cancelAnimationFrame(mediaCounterFrame);
      }
      mediaCounterFrame = window.requestAnimationFrame(updateMediaCounter);
    }, { passive: true });
    updateMediaCounter();

    closeLightbox?.addEventListener('click', hideLightbox);
    prevLightbox?.addEventListener('click', () => showLightboxImage(activeImageIndex - 1));
    nextLightbox?.addEventListener('click', () => showLightboxImage(activeImageIndex + 1));

    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) {
        hideLightbox();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') {
        hideLightbox();
      } else if (event.key === 'ArrowLeft') {
        showLightboxImage(activeImageIndex - 1);
      } else if (event.key === 'ArrowRight') {
        showLightboxImage(activeImageIndex + 1);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
